/* eslint-disable @next/next/no-before-interactive-script-outside-document */

import Script from "next/script";
import { VWOScript } from "vwo-smartcode-nextjs";

const ConnectThirdPartyServer = ({ nonce }: { nonce: string }) => {

  return (<>
    <Script
      key="gtag"
      src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_G_TAG_ID}`}
      data-testid="locl-gtag-script-preload"
      strategy="beforeInteractive"
      nonce={nonce}
    />
    <Script
      nonce={nonce}
      data-testid="locl-gtag-script-inti"
      strategy="beforeInteractive"
      key="gtagScript"
      id="google-analytics"
    >
      {`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${process.env.NEXT_PUBLIC_G_TAG_ID}');
      `}
    </Script>
    <VWOScript
      accountId="883735"
      scriptAttributes={{ nonce }}
    />
    {process.env.SENTRY_ENVIRONMENT !== "production" && process.env.NEXT_PUBLIC_ONE_TRUST_ID && (
      <Script
        defer
        src={`https://cdn-ukwest.onetrust.com/consent/${process.env.NEXT_PUBLIC_ONE_TRUST_ID}/OtAutoBlock.js`}
        strategy="beforeInteractive"
        nonce={nonce}
      />
    )}
    {
      process.env.NEXT_PUBLIC_ONE_TRUST_ID && (
        <Script
          defer
          src="https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js"
          data-domain-script={process.env.NEXT_PUBLIC_ONE_TRUST_ID}
          nonce={nonce}
          data-testid="locl-script-onetrust"
          id="ot-sdk"
          strategy="beforeInteractive"
        />
      )
    }
  </>)
}

export default ConnectThirdPartyServer;
